var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"default-layout"}},[_c('div',{staticClass:"wrapper"},[_c('top-bar'),_c('side-bar'),_c('div',{staticClass:"content-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('v-app',{attrs:{"id":"app-bar"}},[_c('router-view')],1)],1)]),_c('br'),_c('footer-menu')],1)],1),_c('theme-settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }